"use strict";
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var longRunningDescriptor_1 = require("./longRunningCalls/longRunningDescriptor");
exports.LongrunningDescriptor = longRunningDescriptor_1.LongRunningDescriptor;
var pageDescriptor_1 = require("./paginationCalls/pageDescriptor");
exports.PageDescriptor = pageDescriptor_1.PageDescriptor;
var streamDescriptor_1 = require("./streamingCalls/streamDescriptor");
exports.StreamDescriptor = streamDescriptor_1.StreamDescriptor;
var bundleDescriptor_1 = require("./bundlingCalls/bundleDescriptor");
exports.BundleDescriptor = bundleDescriptor_1.BundleDescriptor;
//# sourceMappingURL=descriptor.js.map